module.exports = __webpack_public_path__ + "img/matter.2cda11ec.png";